var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrientation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 248,
    height: 330,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(38 15.374 197.44)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 210,
    fill: "#D8D8D8",
    rx: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 199.8,
    r: 5.4,
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 174,
    x: 15,
    y: 16.8,
    fill: "#282828",
    rx: 4.8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    d: "M139.21 1L141 13.978l-12.347-4.09z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D8D8D8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M137.063 9.178C134.38 4.2 129.19 1 123.105 1 114.158 1 107 8.111 107 17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    d: "M108.79 329L107 316.022l12.347 4.09z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D8D8D8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M110.937 320.822C113.62 325.8 118.81 329 124.895 329c8.947 0 16.105-7.111 16.105-16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrientation);
export default __webpack_public_path__ + "static/media/orientation.3c1276a31753c54e43362076fea3f7de.svg";
export { ForwardRef as ReactComponent };